import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';

export function useUserChangePasswordMutationApi() {
  return useBaseMutation<{ password: string; currentPassword: string }, never>({
    url: '/customer-management/um/users/profile?change=password',
    method: HttpMethod.put,
  });
}
